
export interface GridItemPosition {
    col_start: number
    row_start: number
}

export interface GridItemSize {
    col_span: number
    row_span: number
}

export interface GridItemStyle {
    backgroundColor?: string
    color?: string
    fontFamily?: string
    fontSize?: string
    fontStyle?: string
    fontWeight?: string
    height?: string
    objectFit?: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down'
    objectPosition?: string
    opacity?: number
    outlineColor?: string
    outlineStyle?: 'solid' | 'dashed' | 'dotted' | 'double'
    outlineWidth?: string
    textAlign?: 'left' | 'center' | 'right'
    textDecoration?: string
    transformOrigin?: string | number;
    width?: string
    transform?: string;
}

export interface GridItemData {
    id: string
    assetId: string
    type: 'TEXT' | 'PRODUCT' | 'FILE' | 'COLOR' | 'EXTERNAL_IMAGE'
    content: {
        text?: string
        src?: string
        /** Optimised thumbnail URL (extra-large). Used in the sidebar. */
        previewSrc?: string
        /** Bucket-resized URL. Used on the canvas for fast rendering. */
        resizedSrc?: string
        alt?: string
        mimeType?: string
        link?: string
    }
    position: GridItemPosition
    size: GridItemSize
    styles: React.CSSProperties
    childStyles?: GridItemStyle
    zIndex: number
    mobilePosition?: GridItemPosition
    mobileSize?: GridItemSize
}

export type ActiveDragData = {
    type: 'new-item' | 'move' | 'resize' | 'existing-image'
    itemType?: 'TEXT' | 'PRODUCT' | 'EXTERNAL_IMAGE' | 'FILE' | 'COLOR'
    item?: GridItemData
    handle?: string
    imageUrl?: string
    originalSrc?: string
    imageAlt?: string
    previewSrc?: string
    itemId?: number
    collectionSlug?: string
    colorValue?: string
    mimeType?: string
}

export interface FontVariant {
    file: string;
    name?: string;
    weight?: number;
    style?: string;
}

export interface Font {
    family: string;
    variants: FontVariant[];
}

export interface BrandingColor {
    name: string;
    value: string;
}

export interface PlatformAssets {
    fonts: Font[],
    colors: BrandingColor[]
}

export interface AssetsState extends PlatformAssets {
    loading: boolean;
    error: string | null;
}

export type GroupBounds = {
    left: number
    top: number
    width: number
    height: number
}

export type GridMetrics = {
    colWidth: number
    rowHeight: number
}

export const GRID_INDEX_OFFSET = 1

export type AlignmentParams = 
    | { direction: "HORIZONTAL"; alignment: "left" | "center" | "right" }
    | { direction: "VERTICAL"; alignment: "top" | "middle" | "bottom" };
